import Measurer from './Measurer';
import { getProviders } from './ExternalProviders/ProviderFactory';

export default class ExternalMeasurer extends Measurer {
  constructor() {
    super();
    this.providers = [];
  }

  async onUpdate(nextState, prevState, changes) {
    super.onUpdate(nextState, prevState, changes);

    if(!this.rootContainer && (nextState.display && nextState.display.container)) {
      this.rootContainer = nextState.display.container;
    }

    if(changes.configuration && changes.configuration.Measurement.measurement_providers) {
      this.providers = await getProviders(nextState.configuration.Measurement.measurement_providers, this.rootContainer);
    }

    if(this.providers.length) {
      this.providers.forEach(provider => provider.update && provider.update(nextState, prevState, changes));
    }
  }
}


// WEBPACK FOOTER //
// ./src/Services/Measurement/ExternalMeasurer.js